import { Injectable, EmbeddedViewRef, ComponentFactoryResolver, ApplicationRef, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { NetworkCheckComponent } from '../commonComponents/network-check/network-check.component';
import { LoaderComponent } from '../commonComponents/loader/loader.component';

@Injectable({
  providedIn: 'root'
})
export class RestAPIService {
  private _permissionPaload: any = [];

  get permissionsPayload() {
    return this._permissionPaload;
  }
  set permissionsPayload(data) {
    this._permissionPaload = data;
  }

  component: any
  loaderComponentRef: any;
  API_URL = 'https://api.dev.openbanking.disruptionsuite.io';

  constructor(private http: HttpClient, private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef, private injector: Injector) { }

  private extractData(res: Response) {
    let resObj: any = res;
    return resObj || {};
  }
  private getExtractData(res: Response) {
    localStorage.setItem('status-code', res.status.toString());

    localStorage.setItem('consent-type', res.headers.get('type'));
    localStorage.setItem('payments-type', res.headers.get('sub-type'));
    localStorage.setItem('redirectURL', res.headers.get('Location'));


    let resObj: any = res.body;
    return resObj || {};
  }
  //
  postAPI(cPath, bodyObj): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-cookie': localStorage.getItem('OB_Session')
        //'x-cookie': 'OB_Session=-LpCSaE7YE4p0KpsAE2g' // 'accounts'
        //'x-cookie': 'OB_Session=-LnGwbu8wf77wuz9npxH' // 'funds'
        //'x-cookie': 'OB_Session=-LnHJJS8fmwYqTDqv4AB' // 'accounts'
        //'x-cookie': 'OB_Session=-LpDVRSOS52q6nfgrK1l' // 'domestic & internation Payments'
        //'x-cookie': 'OB_Session=-LnRHXDx2dyOXjts1O6s' // 'File Payments'
      }),
      observe: 'response' as 'body'
    };
    if (navigator.onLine) {
      // this.showLoader();
      return this.http.post<any>(this.API_URL + cPath, bodyObj, httpOptions).pipe(
        tap((data) => {
          if (cPath == '/authentication/code' || cPath == '/authentication/cancel') {
            localStorage.setItem('redirectURL', data.headers.get('Location'));
          }
          // this.hideLoader();
        }),
        map(this.getExtractData),
        // catchError(this.handleError<any>())
      );
    } else {
      localStorage.setItem('errorMessage', 'Ooops! You are not connected internet. Please check :-)');
      this.appendNetWorkError();
    }
  }


  getAPI(cPath): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-cookie': localStorage.getItem('OB_Session')
        //'x-cookie': 'OB_Session=-LpCSaE7YE4p0KpsAE2g' // 'accounts'
        //'x-cookie': 'OB_Session=-LnGwbu8wf77wuz9npxH' // 'funds'
        //'x-cookie': 'OB_Session=-LnHJJS8fmwYqTDqv4AB' // 'accounts'
        //'x-cookie': 'OB_Session=-LpDVRSOS52q6nfgrK1l' // 'domestic & internation Payments'
        //'x-cookie': 'OB_Session=-LnRHXDx2dyOXjts1O6s' // 'File Payments'
      }),
      observe: 'response' as 'body'
    };
    if (navigator.onLine) {
      // this.showLoader();
      return this.http.get<any>(this.API_URL + cPath, httpOptions).pipe(
        tap((data) => {
          // this.hideLoader();
        }),
        map(this.getExtractData),
        // catchError(this.handleError<any>())
      );
    } else {
      localStorage.setItem('errorMessage', 'Ooops! You are not connected internet. Please check :-)');
      this.appendNetWorkError();
    }
  }
  getPlainRequest(path): Observable<any> {
    return this.http.get<any>(path);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (httpError: any): Observable<T> => {
      localStorage.setItem('status-code', httpError.status.toString());
      if (httpError.error !== null && httpError.error.message) {
        localStorage.setItem('errorMessage', httpError.error.message);
      } else {
        localStorage.setItem('errorMessage', 'Sorry, unable to process your request at moment !');
      }
      this.hideLoader();
      this.appendNetWorkError();
      return of(result as T);
    };
  }

  appendNetWorkError() {
    this.component = NetworkCheckComponent;
    // 1. Create a component reference from the component 
    const componentRef = this.componentFactoryResolver.resolveComponentFactory(this.component).create(this.injector);
    // 2. Attach component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(componentRef.hostView);
    // 3. Get DOM element from component
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    // 4. Append DOM element to the body
    document.body.appendChild(domElem);
    // 5. Wait some time and remove it from the component tree and from the DOM
    setTimeout(() => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
    }, 3000);
  }

  showLoader() {
    this.component = LoaderComponent;
    // 1. Create a component reference from the component 
    this.loaderComponentRef = this.componentFactoryResolver.resolveComponentFactory(this.component).create(this.injector);
    // 2. Attach component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(this.loaderComponentRef.hostView);
    // 3. Get DOM element from component
    const domElem = (this.loaderComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    // 4. Append DOM element to the body
    document.body.appendChild(domElem);
    // 5. Wait some time and remove it from the component tree and from the DOM

  }
  hideLoader() {
    this.appRef.detachView(this.loaderComponentRef.hostView);
    this.loaderComponentRef.destroy();
  }

}
